module.exports = __webpack_public_path__ + "img/antes_despues_219.cca02d26.png";